import styles from "./TextBlock.module.scss";
import { Props } from "./types";

function TextBlock({ html }: Props): React.JSX.Element {
  return (
    <div
      className={styles.textBlock}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}

export default TextBlock;
